module.exports = __webpack_public_path__ + "static/media/dad.1051652b.png";